import animateScrollTo from 'animated-scroll-to';

function setScrollLeft(element, scrollLeft, duration = 0) {
  animateScrollTo([scrollLeft, null], {
    elementToScroll: element,
    maxDuration: duration,
    minDuration: duration,
  });
}

function nativeSetScrollLeft(element, scrollLeft) {
  element.scrollLeft = scrollLeft;
}

function getOffsetTop(element) {
  return element.offsetTop;
}

function getOffsetLeft(element) {
  return element.offsetLeft;
}

function getRelativeOffset(element) {
  const childPosition = {
    top: element.offsetTop,
    left: element.offsetLeft,
  };
  const parentElement = element.parentElement;
  const parentPosition = {
    top: parentElement.offsetTop,
    left: parentElement.offsetLeft,
  };

  return {
    top: childPosition.top - parentPosition.top,
    left: childPosition.left - parentPosition.left,
  };
}

function hasIntersectionObserver() {
  return (
    'IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype
  );
}

function getWindowScrollTop() {
  return (
    window.pageYOffset ||
    window.document.documentElement.scrollTop ||
    window.document.body.scrollTop ||
    0
  );
}

function setWindowScrollTop(scrollTop, duration = 0) {
  animateScrollTo([null, scrollTop], {
    maxDuration: duration,
    minDuration: duration,
  });
}

function getWindowHeight() {
  let windowHeight;

  if (window.innerHeight) {
    windowHeight = window.innerHeight;
  } else {
    windowHeight = document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
  }

  return windowHeight;
}

function getBodyHeight() {
  return window.document.body.offsetHeight;
}


function getElementScrollTop(element) {
  return element.scrollTop;
}

function setElementScrollTop(element, scrollTop) {
  element.scrollTop = scrollTop;
}

function getElementWidth(element) {
  return element.offsetWidth;
}

function getElementHeight(element) {
  return element.offsetHeight;
}

function getElementScrollContentHeight(element) {
  return element.scrollHeight;
}

function getVisibleHeightInViewport(element) {
  const rect = getElementRect(element);
  const windowHeight = getWindowHeight();

  const visibleHeight = Math.max(0, rect.top > 0
    ? Math.min(rect.height, windowHeight - rect.top)
    : Math.min(rect.bottom, windowHeight)
  );

  return parseInt(visibleHeight, 10);
}

export {
  setScrollLeft,
  getOffsetTop,
  getOffsetLeft,
  getRelativeOffset,
  hasIntersectionObserver,
  getWindowScrollTop,
  setWindowScrollTop,
  getWindowHeight,
  getBodyHeight,
  getElementScrollTop,
  setElementScrollTop,
  getElementWidth,
  getElementHeight,
  getElementScrollContentHeight,
  getVisibleHeightInViewport,
  nativeSetScrollLeft
};
